module.exports = {
      id: "ic-commodities-normal-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-dbc6d5.smartcharts.svg#ic-commodities-normal-usage",
      toString: function () {
        return this.url;
      }
    }